import {IHowItWorksContent, IHowItWorksState} from "./Helper";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import {getHowItWorksContent} from "./ActionCreators";

const initialValue: IHowItWorksState = {
    content: {
        videoUrl: "",
        videoThumbnail: "",
        steps: []
    },
    loading: false
}

const howItWorksSlice = createSlice({
    name: SliceNames.HOW_IT_WORKS,
    initialState: initialValue,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(
            getHowItWorksContent.pending, (state) => {
                state.loading = true
            })
            .addCase(
                getHowItWorksContent.fulfilled, (state, action: PayloadAction<IHowItWorksContent>) => {
                    state.content = action.payload
                    state.loading = false
                })
            .addCase(
                getHowItWorksContent.rejected, (state) => {
                    state.loading = false
                })
    }
})

export default howItWorksSlice.reducer
